import React, {Component} from 'react';
import {
  Collapse,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  Navbar,
  NavbarBrand,
  NavItem,
  UncontrolledDropdown
} from 'reactstrap';
import {Link} from "../link/Link";
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import {connect} from "react-redux";
import joinPath from "path.join";
import {openSearch} from "../../redux/action/search_actions";
import {setCloseNavBar} from "../../redux/action/navbar_actions";
import { history } from '../../redux/store';
import {Hamburger} from "../hamburger/Hamburger";

class NavigationContainer extends Component {

  constructor( props = {}, context ) {
    super( props, context );

    this.state = {
      isOpen: false,
      scrolled: false,
      mobileProductOpen: false
    };

    this.toggle = this.toggle.bind(this);
    this.close = this.close.bind(this);
    this.props.setCloseNavBar(this.close);

    this.unsubscribeHistoryListener = history.listen( location => {
      this.setState({ location });
    });
  }

  componentWillMount(){
    this.unsubscribeResizeListener = Observable
      .fromEvent(window, 'resize')
      .subscribe( event => {
        if( event.target.innerWidth >= 992 ){
          this.close();
        }
      });
  }

  componentWillUnmount(){
    if( typeof this.unsubscribeResizeListener === 'function' )
      this.unsubscribeResizeListener();

    if( typeof this.unsubscribeHistoryListener === 'function' )
      this.unsubscribeHistoryListener();
  }

  componentDidMount() {
     window.addEventListener('scroll', this.handleScroll.bind(this));
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  close() {
    this.setState({
      isOpen: false,
      mobileProductOpen: false
    });
  }

  handleScroll() {
    const scroll = window.scrollY
                  || window.pageYOffset
                  || document.documentElement.scrollTop;
    this.setState({
      scrolled: scroll > 0
    });
  }

  locationMatches(location){
    const { pathname } = window.location;
    return pathname.startsWith('/en' + location) ? 'active' : '';
  }

  render() {

    const solutions = this.props.solutions.map( s => {
      return (
        <Link to={ joinPath('/solutions/', s.slug) } tag={"div"} key={s.id}>
          <DropdownItem className={this.locationMatches(joinPath('/solutions/', s.slug))}>
            <a>{ s.name }</a>
          </DropdownItem>
        </Link>
      )
    });

    solutions.unshift(
      <Link to="/solutions" tag={"div"} key={-2}>
        <DropdownItem className={this.locationMatches("/solutions")}>
          <a>Solution Areas</a>
        </DropdownItem>
      </Link>,
      <DropdownItem divider key={-1}/>
    );

    const solutions_mobile = this.props.solutions.map( s => {
      return (
        <div key={s.id} className={this.locationMatches(joinPath('/solutions/', s.slug))}
             onClick={this.close}>
          <Link to={ joinPath('/solutions/', s.slug) } >
            { s.name }
          </Link>
        </div>
      )
    });

    solutions_mobile.unshift(
      <div className={this.locationMatches("/solutions")} onClick={this.close} key={-2}>
        <Link to="/solutions">Solution Areas</Link>
      </div>,
      <div className={"divider"} key={-1}/>
    );

    return (
      <Navbar className={"justify-content-between " + (this.state.scrolled ? "scrolled " : "") + (this.state.isOpen ? "open" : "") } fixed="top" dark expand="lg">
        <div className="nav-backdrop"/>
        <Container className={"navbar-body"}>
          <NavbarBrand tag="div" className="ml-3">
            <Link to="/">
              <img width="100px" src={require('../../assets/images/logo.png')} alt="obelux-logo"/>
            </Link>
          </NavbarBrand>
          <Hamburger onClick={this.toggle} value={this.state.isOpen}/>
          <Collapse className="justify-content-end" isOpen={this.state.isOpen} navbar>
            <Nav navbar className="py-2 py-lg-0">

              <UncontrolledDropdown color="link" className={"d-none d-lg-block"}>
                <DropdownToggle caret color="link">
                  <span className={"pl-3 px-lg-0 py-1 py-lg-0 ml-lg-4 dropdown-item-toggle " + this.locationMatches("/solutions")}>
                    Products
                  </span>
                </DropdownToggle>
                <DropdownMenu>{ solutions }</DropdownMenu>
              </UncontrolledDropdown>

              <div className={"d-lg-none"}>
                <NavItem className={ "px-3 px-lg-0 py-1 py-lg-0 ml-lg-4" + this.locationMatches("/news")}
                         onClick={() => this.setState({mobileProductOpen: !this.state.mobileProductOpen})}>
                  <span className={"nav-link dropdown-toggle " + this.locationMatches("/solutions")}>Products</span>
                </NavItem>
                {
                  this.state.mobileProductOpen &&
                  <div className={"nav-dropdown-mobile"}>
                    { solutions_mobile }
                  </div>
                }
              </div>

              <NavItem className={"px-3 px-lg-0 py-1 py-lg-0 ml-lg-4 " + this.locationMatches("/news")}
                       onClick={this.close}>
                <Link to="/news">News</Link>
              </NavItem>
              <NavItem className={"px-3 px-lg-0 py-1 py-lg-0 ml-lg-4 " + this.locationMatches("/about")}
                       onClick={this.close}>
                <Link to="/about">About Us</Link>
              </NavItem>
              <NavItem className={"px-3 px-lg-0 py-1 py-lg-0 ml-lg-4 " + this.locationMatches("/support")}
                       onClick={this.close}>
                <Link to="/support">Support</Link>
              </NavItem>
              <NavItem className={"px-3 px-lg-0 py-1 py-lg-0 ml-lg-4 " + this.locationMatches("/contact")}
                       onClick={this.close}>
                <Link to="/contact">Contact Us</Link>
              </NavItem>
              <NavItem className="px-3 px-lg-0 py-1 py-lg-0 ml-lg-5 mr-3 d-none d-lg-block">
                <span onClick={ () => this.props.openSearch(!this.props.open) }
                   className="open-search obelux-icons pointer" aria-hidden="true" >&#xE002;</span>
              </NavItem>
              <NavItem className="px-3 px-lg-0 py-1 py-lg-0 ml-lg-5 mr-3 d-inline-block">
                <span className={"d-lg-none nav-link"}
                      onClick={ () => this.props.openSearch(!this.props.open) }>Search</span>
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    );
  }

}

export const Navigation = connect(
  state => ({
    open: state.search.open,
    solutions: ( state.resolve.data && state.resolve.data.solutions ) || []
  }),
  dispatch => ({
    openSearch: (open) => dispatch(openSearch(open)),
    setCloseNavBar: close => dispatch(setCloseNavBar(close))
  })
)(NavigationContainer);





// WEBPACK FOOTER //
// ./src/components/navigation/Navigation.js